import { NavMarker } from 'react-rhumb';
import { Image } from 'foundations-components/transitional/components/Image';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import SignupLink from 'LoginUI/components/legacyLogins/shared/SignupLink';
import LoginForm from './LoginForm';
// @ts-expect-error not converted to TS
import ImageUrl from 'LoginUI/images/imageUrls.js';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoginLanding = ({
  allowFbSignup,
  signupParams,
  loginRedirectUrl,
  loginSubmit,
  googleLoginClick,
  ssoLoginClick,
  isInvalidTokenAlertVisible,
  hideSignupLink,
  pageId
}) => {
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "LEGACY_LOGIN_LOAD",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignSelf: "center",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      paddingBlockStart: "500",
      children: [/*#__PURE__*/_jsx(Link, {
        href: "https://www.hubspot.com",
        children: /*#__PURE__*/_jsx(Image, {
          src: ImageUrl.hubspotLogo,
          blockSize: '180',
          alt: "Hubspot Homepage"
        })
      }), !hideSignupLink && /*#__PURE__*/_jsx(SignupLink, {
        isFbSignin: allowFbSignup
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | string[]' is not assignable to type... Remove this comment to see the full error message
        ,
        signupParams: signupParams,
        loginRedirectUrlQueryParam: loginRedirectUrl,
        pageId: pageId
      }), /*#__PURE__*/_jsx(View, {
        maxInlineSize: "500px",
        children: /*#__PURE__*/_jsx(LoginForm
        // @ts-expect-error ts-migrate - clash between functional and class components
        , {
          onLoginSubmit: loginSubmit,
          onGoogleLoginClick: googleLoginClick,
          onSsoLoginClick: ssoLoginClick,
          isInvalidTokenAlertVisible: isInvalidTokenAlertVisible,
          loginRedirectUrl: loginRedirectUrl
        })
      })]
    })
  });
};
export default LoginLanding;